<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import lodash from 'lodash';
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowNumVialsMixedPerMixingLocation',
    extends: TableRowBase,
    data() {
      return {
        fields: [
          'scit_vials_total',
          'slit_vials_total',
        ],
      };
    },
    computed: {
      actualVialsRaw() {
        return lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(this.curMonth[field])
        }, 0);
      },
      actualValueRaw() {
        return this.round(this.getRatio(this.actualVialsRaw, this.curMonth['num_mixing_locations']), 2);
      },
      benchmarkVialsRaw() {
        return lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(this.benchmarkMonth[field])
        }, 0);
      },
      benchmarkValueRaw() {
        return this.round(this.getRatio(this.benchmarkVialsRaw, this.benchmarkMonth['num_mixing_locations']), 2);
      },
      benchmarkVariance() {
        return this.round(this.actualValueRaw - this.benchmarkValueRaw, 2);
      },
      benchmarkValueDiff() {
        return (this.benchmarkValueRaw === '-') ? '-' : this.round(this.getValueDiff(this.actualValueRaw, this.benchmarkValueRaw), 2);
      },
      benchmarkYtdVariance() {
        return this.round(this.actualYtdRaw - this.benchmarkYtdRaw);
      },
      benchmarkYtdValueDiff() {
        return this.benchmarkYtdRaw === 0 ? '-' : this.round(this.getValueDiff(this.actualYtdRaw, this.benchmarkYtdRaw));
      },
      previousVialsRaw() {
        return lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(this.prevYearMonth[field])
        }, 0);
      },
      previousValueRaw() {
        return this.round(this.getRatio(this.previousVialsRaw, this.prevYearMonth['num_mixing_locations']), 2);
      },
      previousYearValueDiff() {
        return this.prevYearNull ? 'N/A' : this.round(this.getValueDiff(this.actualValueRaw, this.previousValueRaw), 2);
      },
      previousYearVariance() {
        return (this.actualValue === '-') ? 0 : this.round(this.actualValueRaw - this.previousValueRaw, 2);
      },
      previousYtdVariance() {
        return this.round(this.actualYtdRaw - this.previousYtdRaw, 2);
      },
      previousYtdValueDiff() {
        return this.prevYearNull ? 'N/A' : this.round(this.getValueDiff(this.actualYtdRaw, this.previousYtdRaw));
      },

    },
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        const tests = lodash.reduce(this.fields, (sum, field) => {
          return sum + this.getYtdByField(yearObj, field, throughMonth)
        }, 0);
        const locations = this.getYtdByField(yearObj, 'num_mixing_locations', throughMonth);
        return this.round(this.getRatio(tests, locations), 2);
      },
    },
  };
</script>
